export const SL = {
  preparing_zip: "Pripravljanje zip…",
  compressing: "Stiskanje…",
  info_icon: "Ko je označeno kot zaključeno, se ne more pridružiti ali dodati nobenih dodatnih članov in vse klepetalnice bodo deaktivirane. Upoštevajte, da bodo projekt, vse klepetalnice in podatki ostali dostopni v deaktiviranem stanju.",
  mark_is_done: "Ali ste prepričani, da želite označiti projekt kot zaključen? Ko je označen, se ne more pridružiti ali dodati nobenih dodatnih članov in vse klepetalnice bodo deaktivirane. Upoštevajte, da bodo projekt, vse klepetalnice in podatki ostali dostopni v deaktiviranem stanju.",
  mark_not_done: "Ali ste prepričani, da želite ponovno odpreti projekt? Ko je označen kot odprt, se lahko pridružijo ali dodajo dodatni člani in vse klepetalnice bodo ponovno aktivirane.",
  mark_as_completed: "Označi projekt kot zaključen",
  room_completed: "Projekt zaključen",
  room_members: "Člani projekta",
  deactivated_rooms: "Deaktivirani projekti",
  deactivated_chats: "Deaktivirane klepetalnice",
  completed_rooms: "Zaključeni projekti",
  request_to_join_a_room: 'Prošnja za pridružitev projektu',
  wants_to_rejoin_room: 'Username se želi znova pridružiti projektu Roomname.',
  invited_you_to_join_room: 'Username vas je povabil, da se pridružite projektu Roomname.',
  restart: "Ponovno zaženi",
  update_text: "Na voljo je nova posodobitev. Kliknite na ponovno zaženi za namestitev posodobitve.",
  update_availble: "Posodobitev na voljo",
  Loading: "Nalaganje...",
  logout: "Odjava",
  back: 'Nazaj',
  company_list: "Seznam podjetij",
  followers: "Sledilci",
  followings: "Sledim",
  article: "Članek",
  companies: "Podjetja",
  one_to_one_chat: " Neposredno klepetanje",
  profile: "Profil",
  company: "Podjetje",
  company_selection: "Izbira podjetja",
  home: "Domov",
  contact: "Stik ",
  add_company: "Dodaj podjetje ",
  add_project: "Dodaj projekt ",
  capacities: "Kapacitete ",
  work_area: "Delovno področje",
  company_services: "Storitve podjetja",
  website: "Spletna stran",
  search_contacts: "Išči stike",
  add_or_join_a_company: "Dodaj ali pridruži se podjetju",
  follow: "Sledi",
  following: "Sledim",
  like: "Všeč mi je",
  company_contacts: "Stik podjetja",
  leave_the_company: "Zapusti podjetje",
  news: "Novice",
  earlier: "Prej",
  action: "Dejanje",
  another_action: "Drugo dejanje",
  something_else: "Nekaj drugega",
  search: "Iskanje",
  search_rooms: "Išči projekte",
  search_articles: "Išči članke",
  contacts: "Stiki",
  suggestions: "Predlogi",
  project_list: "Seznam projektov",
  search_results: "Rezultati iskanja",
  add_or_join_project: "Dodaj ali pridruži se projektu",
  details: "Podrobnosti",
  your_position_within_company:
    "Prosimo, izberite svoj položaj v podjetju.",
  close_modal: "Zapri",
  map: "Zemljevid",
  or: "Ali",
  name: "Ime*",
  street: "Ulica*",
  house_number: "Hišna št.",
  postal_code: "Poštna številka",
  city: "Mesto*",
  opened_by: "Odprl:",
  project_No: "Projekt-št: ",
  building_type: "Tip stavbe*",
  building_types: "Tip stavbe",
  add_join: "Dodaj/Pridruži se",
  mandatory_fiels: "*obvezna polja",
  invalid_fiels: "To polje je obvezno",
  add_or_join_company: "Dodaj ali pridruži se podjetju",
  name_of_the_company: "Ime podjetja",
  edit_company_details: "Uredi podrobnosti podjetja",
  branch_of_the_building_industry: "Panoga gradbene industrije",
  corporate_form: "Pravna oblika",
  position_within_company: "Položaj v podjetju",
  request_confirmation: "Čakajoče prošnje za projekt",
  company_e_mail: "E-pošta podjetja",
  type_of_filter: "Vnesite za filtriranje...",
  setting: "Nastavitev",
  dashboard: "Nadzorna plošča",
  settings: "Nastavitve",
  views: "Ogledi",
  times_seen: "krat videno",
  see_more: "...več",
  see_less: "...manj",
  in_search: "v iskanju",
  reset_password: "Ponastavi geslo",
  submit: "Pošlji",
  password: "Geslo",
  email: "E-pošta",
  confirm_password: "Potrdi geslo",
  reset_email: "Ponastavi e-pošto",
  update: "Posodobi",
  new_email: "Nova e-pošta",
  kjuup_message: "Kjuup Sporočilo",
  delete_profile: "Izbriši profil?",
  my_position: "Moj položaj:",
  add: "dodaj",
  owner_company_admin: "Administrator podjetja :",
  owner_company_admin_new: "Administrator podjetja",
  mutual_contact: "skupen stik",
  mutual_contacts: "skupni stiki",
  co_owner: "Sozakonec",
  managing_director: "Direktor",
  associate: "Sodelavec",
  secretary: "Sekretar",
  employee: "Zaposleni",
  project_manage: "Vodja projekta",
  auto_chat_translation: "Samodejni prevod klepeta",
  translate_room_group_names: "Prevajaj imena projektov in skupin",
  translate_room_group_names_info: "Če je vklopljeno, se imena projektov in skupin za klepet samodejno prevedejo v jezik vmesnika.",
  default_view_email: "Default View: E-Mail",
  default_view_email_info: "Ko je omogočeno, se bo ob odprtju aplikacije privzeto odprl zavihek E-Mail namesto Sporočil.",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "Jezik",
  english: "Angleščina",
  german: "Nemščina",
  french: "Francoščina",
  italian: "Italijanščina",
  change_language: "Spremeni jezik",
  my_companies: "Moja podjetja",
  employees: "Zaposleni",
  invite_with_a: "Povabi v Kjuup",
  add_member: "Dodaj člana",
  add_user: "Dodaj uporabnika",
  send_location: "Pošlji lokacijo",
  assign_admin_rights: "Prilagodi skrbniške pravice",
  deactivate_company: "Deaktiviraj podjetje",
  remove_employees: "Odstrani zaposlene",
  remove_members: "Odstrani člane",
  no_user_found: "Uporabnik ni najden!",
  approve: "Odobri!",
  deselect_all: "Odstrani vse izbire",
  select_all: "Izberi vse",
  translation_on_building_projects: "Prevod v projektih",
  reported_capacities: "Prijavljene storitve",
  up_to_50m_exact: "Do 50m natančno",
  company_details_service: "Storitve podjetja",
  company_contact: "Stik podjetja",
  invite_with_link: "Povabi v Kjuup",
  share_link: "Deli povezavo",
  share_company_link: "Deli povezavo",
  qr_code: "QR koda",
  copy_link: "Kopiraj povezavo",
  cancel_link: "Prekliči povezavo",
  who_has_confirmed_services: "Kdo je potrdil vaše storitve?",
  projectss: "Projekti",
  add_services: "Dodaj storitve",
  services: "Storitve",
  save_text: "Shrani",
  share_on: "Deli na:",
  articlen: "Članek",
  invite_user_to_confirm_service:
    "Povabi uporabnike, da potrdijo storitve podjetja.",
  link_copied: "Povezava kopirana!",
  email_copied: "E-pošta kopirana!",
  personal_article: "Osebni članek",
  company_article: "Članek podjetja",
  characters_remaining: "Preostalih znakov",
  optional_information: "Neobvezne informacije",
  project: "Projekt",
  projects: "Projekti...",
  abort: "Zavrzi",
  preview: "Predogled",
  post: "Objavi",
  of: "od",
  remove: "Odstrani",
  free_capacity: "Portal za delo",
  current_status_overview: "Pregled trenutnega stanja",
  report_capacities: "Prijavi storitve",
  report_text: "Prijavi",
  search_capacities: "Najdi izvajalce",
  add_project_user: "Dodaj uporabnika projekta",
  media: "Mediji",
  links: "Povezave",
  docs: "Dokumenti",
  featured_products: "Izbrani izdelki...",
  title: "Naslov",
  text: "Besedilo",
  feed_details: "Podrobnosti vira",
  add_employee: "Dodaj zaposlenega",
  latest: "Najnovejše",
  my_projects: "Moji projekti",
  cancel: "Prekliči",
  continue: "Nadaljuj",
  role_in_the_building_industry: "Vloga v gradbeni industriji",
  als: "kot",
  join: "pridruži se",
  find: "Najdi",
  request_to_join_a_company: "Prošnja za pridružitev podjetju",
  wants_to_join_the_company: "se želi pridružiti podjetju",
  filter_by: "Filtriraj po",
  ok: "V redu",
  close: "Zapri",
  weekly_statistics: "Tedenska statistika",
  is_following_you: "vam sledi.",
  as: "kot",
  has_joined_the: "se je pridružil podjetju",
  has_looked_at_your_profile: "si je ogledal vaš profil.",
  time: "čas",
  in_searches_in_past_week: "v iskanjih v preteklem tednu.",
  has_liked_your_article: "mu je všeč vaš članek.",
  has_published_a_new_article: "je objavil nov članek.",
  you: "Vi",
  all_views: "Vsi ogledi",
  all_profile_views: "Vsi ogledi profila",
  mutual_company: "skupno podjetje",
  artical_text: "Napiši članek...",
  you_have_appeared: "Pojavili ste se",
  your_request_at_the_company: "Vaša prošnja pri podjetju",
  times_you_have_appeared_in_searches: "krat ste se pojavili v iskanjih",
  appear_more_often_in_searches: "Pojavljajte se pogosteje v iskanjih",
  you_have_been_found: "Najdeni ste bili",
  improve_profile: "Izboljšaj profil",
  choose_existing_contact_for_single_chat:
    "Izberite obstoječi stik za neposredno klepetanje:",
  in_order_to_add_new_contacts:
    "Za dodajanje novih stikov prosimo iščite nove stike na strani profila.",
  times_in_searches_in_the_last_week:
    "krat v iskanjih v preteklem tednu. Posodobite svoj profil in dodajte dodatne podrobnosti, da vas bodo lažje našli.",
  has_been_confirmed: "je bil potrjen.",
  have_joined_the: "so se pridružili  ",
  building_project: " gradbenemu projektu.",
  select_with_which_company_you_want_to_connect_to_the_project:
    "Izberite podjetje, ki ga boste zastopali. To bo prikazano drugim udeležencem.",
  select_with_which_company_you_want_to_connect_to_the_chat:
    "Izberite podjetje, ki ga boste zastopali. To bo prikazano drugim udeležencem.",
  select_internal_section: "Prosimo, izberite notranji oddelek",
  select_profile_image: "Izberite profilno sliko",
  share_user: "Deli uporabnika",
  contact_sender_message:
    "Delite to povezavo, da povabite nečlana Kjuup v Kjuup. To povezavo lahko uporabi več ljudi za registracijo.",
  project_sender_message:
    "Delite to povezavo, da povabite nečlana Kjuup v projekt ime projekta. To povezavo lahko uporabi več ljudi za registracijo in pridružitev projektu ime projekta v Kjuup.",
  company_sender_message:
    "Delite to povezavo, da povabite nečlana Kjuup v podjetje ime podjetja. To povezavo lahko uporabi več ljudi za registracijo in pridružitev podjetju v Kjuup.",
  contact_receivers_message:
    "Povabilo za pridružitev Kjuup. Prosimo, kliknite povezavo za registracijo v kjuup.",
  iphone: "iPhone:",
  iphone_recivers_message:
    "V primeru, da nameščate Kjuup prek Apple App Store, morate klikniti to povezavo po uspešnem prenosu, da se lahko registrirate.",
  project_receivers_message:
    "Povabilo za pridružitev projektu ime projekta v Kjuup. Prosimo, kliknite povezavo za registracijo v Kjuup in pridružitev projektu ime projekta.",
  company_receivers_message:
    "Povabilo v podjetje ime podjetja v Kjuup. Prosimo, kliknite povezavo za registracijo v Kjuup in pridružitev podjetju ime podjetja.",
  sign_in: "Prijava",
  enter_your_email_add: "Vnesite svoj e-poštni naslov",
  forgot_password: "Pozabljeno geslo",
  dont_have_account: "Nimate računa ?",
  register: "Registracija",
  get_app: "Pridobite aplikacijo",
  registration: "Registracija",
  dep_ing: "Dipl.-Ing.",
  dr: "Dr.",
  dr_ing: "Dr.-Ing.",
  dep_ing_arc: "Dipl.-Ing. Arhitekt",
  prof: "Prof.",
  first_name: "Ime",
  last_name: "Priimek",
  have_an_account: "Imate račun ?",
  when_register_you_agree: "Z registracijo se strinjate z našimi",
  term_of_use: "pogoji uporabe",
  to: "na.",
  in_our: "V naših",
  data_policy: "pravilih o podatkih",
  they_find_out: "izveste,",
  we_provide_store_data: "kako zbiramo, obdelujemo in shranjujemo informacije.",
  leaving_company_text:
    "Ali res želite zapustiti podjetje? Ko zapustite podjetje, boste izgubili dostop do vseh klepetalnic podjetja in projektov.",
  delete_profile_text:
    "Ali res želite izbrisati svoj profil? Ko izbrišete svoj profil, bodo odstranjene vse povezave s podjetji, projekti in klepetalnicami. Novi profil lahko ustvarite kadarkoli.",
  confirm: "Potrdi",
  reject: "Zavrni",
  requet_to_leave: "Prošnja za odhod",
  choose: "Izberi",
  your_add_member: "Dodaj člana",
  if_you: "v primeru, da",
  can_not_find: "ne najdete svojega stika tukaj.",
  please_wait: "Prosimo, počakajte..",
  imprint_gtc: "Impressum/Splošni pogoji",
  register_confirm_popup: "Pred prijavo potrdite svoj Kjuup e-poštni naslov. Poslali smo potrditveno povezavo. Če je ne vidite, preverite tudi mapo vsiljene pošte.",
  PENDING_GROUP_USER:
    "bo prejemal sporočila šele po potrditvi povabila v projekt. Dodatno sporočilo se bo pojavilo, ko bo povabilo v projekt potrjeno.",
  PENDING: "Potrditev povabila v projekt čaka",
  denied_group_chat: " je zavrnil povabilo v projekt in zapustil to skupino.",
  // joined_group_chat: " se je pridružil sobi in tej skupini.",
  joined_group_chat: " se je pridružil tej skupini",
  you_joined_group_chat: "Pridružili ste se tej skupini.",
  Others: "Drugi",
  LEFT_GROUP: "je zapustil to klepetalnico.",
  YOU_LEFT_GROUP: "ste zapustili to klepetalnico.",
  days: "dni",
  day: "dan",
  hour: "ura",
  hide_project: "Skrij projekt",
  hide_project_popup_text:
    "Če skrijete projekte, jih ni mogoče najti v Kjuup. Samo člani projekta lahko povabijo nove uporabnike v projekt.",
  branch: "Panoga",
  photo_video_media_lib: "Foto - Video medijska knjižnica",
  document: "Dokument",
  location_meeting: "Lokacija / Sestanek",
  all_member_of_project: "Vsi člani projekta",
  pending_request: "Čakajoče prošnje za projekt",
  no_pending_request: "Ni čakajočih prošenj!",
  news_feed: "Novice",
  user_info: "Informacije o skupini",
  leave_project: "Zapusti projekt",
  media_link_docs: "Datoteke",
  search_chat: "Išči klepet",
  export_chat_group: "Izvozi podatke klepetalnice iz zadnjega meseca",
  request_complete_chat_history: "Zahtevaj celotno zgodovino klepeta",
  leave_chat_group: "Zapusti klepetalnico",
  add_user_project: "Dodaj uporabnika",
  me: "Jaz",
  max_open_one_to_one:
    "Trenutno je mogoče odpreti največ 2 neposredni klepetalnici vzporedno na spodnjem - in zgornjem delu. Skupno je možnih največ 4 neposredne klepetalnice.",
  are_you_sure_you_want_leave_chat:
    "Ali ste prepričani, da želite zapustiti to klepetalnico?",
  create_group: "Ustvari skupino",
  adding_members: "Dodajanje članov...",
  creating_the_chat: "Ustvarjanje klepeta...",
  finishing_setup: "Zaključevanje...",
  group_name: "Ime skupine",
  by: "Od:",
  mandetory: "*obvezno",
  delteed: "je izbrisal svoj profil in zapustil klepetalnico.",
  deleted_direct: "je izbrisal svoj profil in zapustil klepet.",
  unhidden_message:
    "Če odkrijete projekte, jih lahko najdejo vsi člani Kjuup.",
  account_deleted: "Račun je bil izbrisan.",
  refuse_company: "Ali ste prepričani, da želite zavrniti povabilo podjetja?",
  follow_additional: "Sledi dodatnim uporabnikom",
  f_add:
    "Sledite dodatnim uporabnikom Kjuup, da jih omogočite za neposredna sporočila.",
  c_inv: "Povabilo(a) podjetja",
  invited_o_Company: "Povabljeni ste bili, da se pridružite podjetju",
  refuse_companyX: "Ali ste prepričani, da želite zavrniti prošnjo podjetja?",
  a_Da: "Račun deaktiviran.",
  has_deactivated: "je deaktiviral svoj profil.",
  reactive: "je ponovno aktiviral svoj profil.",
  juup_note: "*Registracija z uporabniškim imenom na voljo samo za člane Kjuup+",
  username: "Uporabniško ime*",
  email_username: "E-pošta/Uporabniško ime*",
  sPinText:
    "Prosimo, navedite 6-mestno varnostno PIN kodo. Ta PIN bo potreben, če pozabite geslo in je obvezen za potrditev vašega računa.",
  DeleteKjuupPlusText:
    "Ali res želite izbrisati svoj profil? Ko izbrišete svoj profil, bodo odstranjene vse povezave s podjetji, projekti in klepetalnicami.\n\nV 48 urah po izbrisu računa lahko svoj račun ponovno aktivirate s prijavo z uporabniškim imenom, geslom in PIN kodo.",
  reactive_text:
    "Vaš račun je bil izbrisan. Prosimo, kliknite na Ponovno aktiviraj za ponovno aktivacijo vašega računa.",
  rac: "Ponovno aktiviraj",
  ac_ss: "Račun uspešno ponovno aktiviran.",
  not_valid_pin: "PIN neveljaven",
  only_for_kjuup:
    "*Ponastavitev gesla prek uporabniškega imena in PIN kode na voljo samo za člane Kjuup+.",
  resetPIN: "Ponastavi PIN",
  enter_current_pin: "Prosimo, vnesite svoj trenutni PIN",
  enter_new: "Vnesite nov PIN",
  pin_to_confirm: "Prosimo, navedite PIN za potrditev.",
  change_username: "Ponastavi uporabniško ime",
  pp_not_match: "Geslo - in Potrdi geslo se ne ujemata",
  reactive_itself: "Ponovno ste aktivirali svoj profil.",
  has_deactivated_itself: "Deaktivirali ste svoj profil.",
  more_than_two:
    "Trenutno je mogoče neposredna sporočila pošiljati samo z 2 uporabnikoma vzporedno.",
  Chats: "Neposredna sporočila",
  only_in_mobileL:
    "Izvorne videoposnetke je trenutno mogoče naložiti in objaviti samo prek mobilne aplikacije. Prosimo, uporabite video povezave Youtube in Vimeo.",
  register_pin_text:
    "Prosimo, izberite svoj osebni 6-mestni PIN. Ta PIN bo potreben za omogočanje funkcij ponastavitve računa.",
  internal_project: "Notranji",
  external_projects: "Zunanji",
  in_deacticted: "Notranji oddelek je deaktiviran.",
  create_article: "Ustvari članek",
  new_article_selection: "Ustvari članek za zunanje novice",
  new_article_selection_internal: "Ustvari interni članek",
  active_trans_title: "Vklopiti samodejni prevod?",
  active_trans: "Ko je vklopljen, vsa dohodna sporočila v klepetu bodo prevedena v vaš izbrani jezik aplikacije.",
  disable_trans: "Ali res želite deaktivirati samodejni prevod?",
  allow_access_chat: "Prikaži celotno zgodovino klepeta",
  toggle_chat_history_on:
    "Ali res želite, da uporabnik vidi celotno zgodovino klepeta?",
  toggle_chat_history_off:
    "Ali res želite, da uporabnik vidi samo zgodovino klepeta od trenutka pridružitve klepetalnici?",
  check_selected_settings:
    "Prosimo, preverite nastavitve za zgodovino klepeta za vse izbrane uporabnike!",
  chat_from_start_have:
    "Pridružili ste se tej skupini. Zgodovina klepeta je bila deljena.",
  chat_from_start_has:
    "se je pridružil tej skupini. Zgodovina klepeta je bila deljena.",
  Address: "Naslov",
  read_by: "Prebral",
  deliver_to: "Dostavljeno",
  remaining: "preostalo",
  message_info: "Informacije o sporočilu",
  request_to_join_only: "Prošnja za pridružitev",
  unfollow: "Prenehaj slediti",
  company_username: "Uporabniško ime",
  month: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "Maj",
    "Jun",
    "Jul",
    "Avg",
    "Sep",
    "Okt",
    "Nov",
    "Dec",
  ],
  remove_my_admin_right: "Odstrani moje skrbniške pravice",
  makeEmp: "Ali res želite odstraniti skrbniške pravice podjetja od uporabnika?",
  remove_my_self:
    "Ali res želite odstraniti skrbniške pravice podjetja iz svojega računa?",
  makeAdmin: "Ali res želite dati uporabniku skrbniške pravice podjetja?",
  remove_member: "Odstrani člana",
  remove_following_confirm: "Ali res želite odstraniti {name} s seznama sledenih?",
  remove_follower_confirm: "Ali res želite odstraniti {name} s seznama vaših sledilcev? Če ga/njo odstranite, ne bo obveščen/a.",
  do_you_really_want_to_remove:
    "Ali res želite odstraniti uporabniško ime iz podjetja?",
  invite_all: "Povabi vse člane podjetja",
  invite_all_members: "Povabi vse člane",
  mems: "Vsi drugi člani",
  dep_loc: "Oddelek/Lokacija/Ekipa",
  depAdmin: "Administrator oddelka",
  add_remove_admin: "Dodaj/Odstrani položaj administratorja podjetja",
  add_remove_dep_admin: "Dodaj/Odstrani položaj administratorja oddelka",
  remove_employees_dept: "Odstrani zaposlene iz",
  want_to_join_dep:
    "Uporabniško ime se želi pridružiti oddelku/lokaciji/ekipi ime oddelka podjetja ime podjetja.",
  you_invited:
    "Povabljeni ste bili, da se pridružite oddelku/lokaciji/ekipi ime oddelka podjetja ime podjetja.",
  dep_remove:
    "Ali res želite odstraniti skrbniške pravice za oddelek ali lokacijo od uporabnika?",
  add_dep:
    "Ali res želite dati uporabniku skrbniške pravice za oddelek ali lokacijo?",
  my_self_dep_remove:
    "Ali res želite odstraniti skrbniške pravice oddelka iz svojega računa?",
  member: "Član",
  admin: "Administrator",
  remove_project_admin:
    "Ali res želite odstraniti člana iz projekta?",
  remove_my_self_project: "Ali res želite odstraniti skrbniške pravice?",
  remove_member_admin_right:
    "Ali res želite odstraniti skrbniške pravice od uporabnika?",
  add_member_admin_right: "Ali res želite dodati skrbniške pravice uporabniku?",
  add_remove_Poss: "Dodaj/Odstrani položaj administratorja",
  forward: "Posreduj",
  edit: "Uredi",
  only_kjuup_plus_can: "Samo podjetja Kjuup+ lahko objavljajo članke.",
  add_images: "Dodaj sliko(e)",
  request_confirmation: 'Čakajoča povabila v projekt',
  Activity: "Aktivnost",
  latest_messages: "Najnovejša sporočila",
  hours: "ure",
  minute: "minute",
  seconds: "sekunde",
  days: "dni",
  yesterday: "včeraj",
  last_week: "prejšnji teden",
  next_week: "naslednji teden",
  Last_month: "prejšnji mesec",
  All: "Vse",
  register_plus: "Registracija Plus",
  select_files: "Izberite datoteke",
  monthsFullName: [
    "Januar",
    "Februar",
    "Marec",
    "April",
    "Maj",
    "Junij",
    "Julij",
    "Avgust",
    "September",
    "Oktober",
    "November",
    "December",
  ],
  company_deploc_receivers_message:
    "Povabilo v oddelek podjetja ime podjetja v Kjuup. Prosimo, kliknite povezavo za registracijo v Kjuup in pridružitev podjetju ime podjetja.",
  no_news: "Ni novic",
  reminder: "Opomnik",
  np_reminder: "Ni opravil",
  move_to_reminder: "Premakni v opravila",
  remove_reminder: "Ali res želite odstraniti to sporočilo s seznama vaših opravil?",
  remove_all_reminder: "Odstrani vsa opravila",
  remove_all_confirm: "Ali res želite odstraniti vsa sporočila s seznama vaših opravil?",
  remove_from_reminder: "Odstrani iz opomnika",
  prevent_email: "E-pošte ni mogoče uporabiti kot uporabniško ime.",
  allow_noti: "Prosimo, omogočite obvestila.",
  join_cap: "Pridruži se",
  pass_minimum:
    "**Geslo zahteva 12 znakov vključno z malo -, veliko črko, številko in posebnim znakom.",
  pass_error: "Prosimo, preverite zahteve za geslo",
  people_that_like_article: "Ljudje, ki jim je všeč članek.",
  people_who_like_article: "Ljudje, ki jim je všeč vaš članek.",
  message_delete: "To sporočilo je bilo izbrisano.",
  message_edited: "urejeno",
  edit_message: "Uredi sporočilo",
  edit_window_expired: "Sporočila je mogoče urejati samo v 10 minutah po pošiljanju.",
  message_edit_save: "Shrani",
  copy: "Kopiraj",
  bookmark: "Zaznamek",
  add_reaction: "Dodaj odziv",
  delete_message: "Izbriši sporočilo",
  more_options: "Več možnosti",
  info: "Info",
  link_invite: "Povabi prek povezave",
  ll_nkk: "Povabi v Kjuup",
  selected: "Izbrano",
  is_active: "Aktivno",
  inactive: "Neaktivno",
  last_online: "nazadnje na spletu {{when}}",
  remove_user_l: "Odstrani",
  link_expire: "Vsaka ustvarjena povezava bo veljavna 72 ur.",
  company_language: "Jezik podjetja",
  company_language_info:
    "Izbira jezika bo uporabljena za vse e-poštne potrditve v zvezi s podjetjem.",
  s_image: "slika",
  m_image: "slike",
  removeMsg: "Tapnite za odstranitev",
  block: 'Blokiraj',
  unblock: 'Odblokiraj',
  unblocks: 'Ali ste prepričani, da želite odblokirati tega uporabnika?',
  bolcked_click_un_block:
    'Blokirali ste ta stik. Kliknite tukaj za odstranitev blokiranja.',
  you_have_unblocked: 'Odblokirali ste ta stik.',
  you_have_blocked: 'Blokirali ste ta stik.',
  unblock_to_send: 'Odblokirajte uporabnika za pošiljanje sporočila.',
  pilot_text: "Specializirana UI za gradbene teme",
  startup_screen_label: "Začetni zaslon",
  startup_screen_info: "Izberite, kateri zaslon se odpre ob zagonu Kjuup.",
  startup_screen_feed: "Home",
  startup_screen_messages: "Sporočila",
  startup_screen_saved: "Začetni zaslon posodobljen",
email_on: "E-poštna obvestila za klepete",
  email_on_grp: "E-poštno obvestilo",
  article_email_on: "Email notification articles",
  article_email_info: "If you enable email notifications for internal articles, you will receive an email when a new internal article is published in your company and department.",
  info_email_room: "Aktivirajte ali deaktivirajte e-poštna obvestila za ta projekt. Ta možnost je na voljo samo, ko je \"E-poštna obvestila za klepete\" omogočena prek osebnih nastavitev.",
  todo_notification_info: "Obveščeni boste vsakič, ko vam bo dodeljena nova naloga.",
  info_val: "Prejeli boste e-pošto, če novo sporočilo v klepetu ni prebrano v kratkem času. To lahko izklopite za posamezne projekte ali klepete v njihovih nastavitvah ali v informacijah o klepetalnici.",
  email_groups: "Aktivirajte ali deaktivirajte e-poštna obvestila za ta klepet. Ta možnost je na voljo samo, ko je \"E-poštna obvestila za klepete\" omogočena prek osebnih - in nastavitev projekta.",
  add_update_email: "Dodaj/Posodobi e-pošto",
  text_to_verifiy: "Možnost \"E-poštna obvestila za klepete\" je mogoče omogočiti samo, če imate potrjen e-poštni naslov v evidenci.",
  stored_email: "Shranjena e-pošta: ",
  verify_email: "Potrditev čaka!",
  join_call:"Pridruži se",
  call_is_started:"Klic se je začel",
  start_chat:"Začni neposredno klepetanje?",
  project_rooms:"Projekti",
  download_selected:"Prenesi",
  add_employee_confirm: 'Ali ste prepričani, da želite dodati tega uporabnika v podjetje?',
  invalid_deeplink: "Neveljavna globoka povezava. Manjkajo zahtevani parametri.",
  deeplink_error: "Ni mogoče obdelati globoke povezave. Prosimo, poskusite znova pozneje.",
  // Reply functionality translations
  reply: "Odgovori",
  reply_enter: "Vnesite odgovor...",
  reply_sent_successfully: "Odgovor uspešno poslan",
  reply_failed: "Pošiljanje odgovora ni uspelo",
  reply_failed_generic: "Pošiljanje odgovora ni uspelo. Prosimo, poskusite znova.",
  replying_to_message: "Odgovarjanje na sporočilo",
  cancel_reply: "Prekliči odgovor",
  voice_message: "Glasovno sporočilo",
  send: "Pošlji",
  cancel: "Prekliči",
  type_your_reply: "Vnesite svoj odgovor...",
  
  // Auto-suggestion translations
  suggested_replies: "Predlagani odgovori",
  suggestions_error: "Nalaganje predlogov ni uspelo",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Image — Click to load",
  lazy_media_audio: "Voice message — Click to load",
  lazy_media_doc: "Document — Click to load",
  lazy_media_video: "Video — Click to load",
  suggestion_loading_message: "Samo trenutek. Vaše besedilo se pripravlja individualno za vas.",
  loading_chat_message: "Nalaganje klepeta...",
  
  // Manual ToDo translations
  extracting_message: "Pridobivanje sporočila...",
  create_todo: "Ustvari opravilo",
  create_todo_confirmation: "Ali želite ustvariti opravilo iz tega sporočila?",
  select_project_required: "Prosimo, izberite projekt/skupino",
  only_assigned_can_change_status: "Samo dodeljeni uporabniki lahko spremenijo status",
  todo_summary: "Povzetek",
  todo_summary_placeholder: "Vnesite povzetek opravila...",
  todo_date: "Datum",
  todo_time: "Čas",
  todo_date_hint: "Pustite prazno za uporabo izvirnega datuma/časa sporočila",
  todo_created_success: "Opravilo uspešno ustvarjeno",
  todo_creation_failed: "Ustvarjanje opravila ni uspelo",
  create: "Ustvari",
  
  image: "slika",
  images: "slike",
  remove_all_images: "Odstrani vse slike",
  remove_image: "Odstrani sliko",
  remove_document: "Odstrani dokument",
  remove_recording: "Odstrani posnetek",
  play_recording: "Predvajaj posnetek",
  upload_image: "Naloži sliko",
  upload_document: "Naloži dokument",
  record_audio: "Posnemi zvok",
  stop_recording: "Ustavi snemanje",
  stop_recording_text: "Ustavi snemanje",
  please_remove_current_attachment: "Prosimo, odstranite trenutno prilogo za",
  please_upload_image_file: "Prosimo, naložite veljavno slikovno datoteko",
  please_upload_valid_document: "Prosimo, naložite veljaven dokument",
  searching_messages: "Iskanje sporočil...",
  loading_more: "Nalaganje več...",
  loading_more_users: "Nalaganje več uporabnikov...",
  load_more_users: "Naloži več uporabnikov",
  no_more_users_to_load: "Ni več uporabnikov za nalaganje",
  no_messages_found: "Sporočila niso bila najdena",
  try_different_keyword: "Poskusite drugo ključno besedo ali preverite črkovanje.",
  search_messages: "Išči sporočila, klepetne skupine, projekte in uporabnike...",
  todo: "Opravilo",
  np_todo: "Ni opravil",
  move_to_todo: "Shrani kot opravilo",
  remove_todo: "Ali res želite odstraniti opravilo?",
  remove_all_todo: "Odstrani vsa opravila",
  remove_all_todo_confirm: "Ali res želite odstraniti vsa opravila?",
  add_to_todo: "Dodaj k opravilom",
  remove_from_todo: "Odstrani iz opravil",
  confirm: "Potrdi",
  ok: "V redu",
  read_more: "Preberi več",
  show_less: "Prikaži manj",
  show_more: "Prikaži več",
  audio: "Zvok",
  video: "Video",
  // Notification Settings
  notification_schedule: "Urnik obvestil",
  notification_schedule_desc: "Push in e-poštna obvestila boste prejemali samo v urah, ki jih izberete. Zunaj teh časov bodo začasno ustavljena.",
  learn_more: "Izvedi več",
  allow_notifications: "Dovoli obvestila:",
  every_day: "Vsak dan",
  weekdays: "Delovni dnevi (ponedeljek do petek)",
  custom: "Po meri",
  monday: "Ponedeljek",
  tuesday: "Torek",
  wednesday: "Sreda",
  thursday: "Četrtek",
  friday: "Petek",
  saturday: "Sobota",
  sunday: "Nedelja",
  to: "do",
  notification_settings: "Obvestila",
  notification_settings_saved: "Nastavitve obvestil uspešno shranjene",
  notification_settings_error: "Shranjevanje nastavitev obvestil ni uspelo",
  unavailability_note: "Obvestilo o nedosegljivosti",
  unavailability_description: "Nastavite obvestilo o odsotnosti. Medtem ko je aktivno, se obvestilo prikazuje drugim v vseh vaših pogovorih in obvestila so začasno ustavljena.",
  unavailability_start_date: "Datum začetka",
  unavailability_end_date: "Datum konca",
  unavailability_message: "Sporočilo",
  unavailability_message_hint: "Uporabite {endDate} kot nadomestni znak za datum vrnitve.",
  unavailability_replacement: "Nadomestni kontakt",
  unavailability_replacement_placeholder: "Vnesite ID uporabnika za nujne zahteve",
  unavailability_replacement_current: "Trenutni namestnik",
  unavailability_replacement_hint: "Če je nastavljeno, bo v obvestilu o nedosegljivosti prikazana povezava za stik s to osebo za nujne zadeve.",
  unavailability_replacement_none: "Brez namestnika (neobvezno)",
  unavailability_contact_urgent: "Za nujne zahteve se obrnite na",
  unavailability_default_message: "Trenutno nisem v pisarni in nimam dostopa do Kjuupa. Ponovno bom dosegljiv/a od {endDate} in se vam takrat oglasim.",
  unavailability_save: "Shrani",
  unavailability_deactivate: "Deaktiviraj",
  unavailability_active_until: "Aktivno do",
  unavailability_saved: "Obvestilo o nedosegljivosti shranjeno",
  unavailability_save_error: "Shranjevanje obvestila o nedosegljivosti ni uspelo",
  unavailability_deactivated: "Obvestilo o nedosegljivosti deaktivirano",
  unavailability_end_date_required: "Datum konca je obvezen",
  start_time_before_end_time: "Začetni čas mora biti pred končnim časom",
  loading: "Nalaganje",
  disabled: "Onemogočeno",
  enable: "Omogoči",
  disable: "Onemogoči",
  forwarded: "Posredovano",
  message_forwarded: "Sporočilo posredovano!",
  // Schedule Article
  schedule_article_post: "Načrtuj objavo članka",
  date: "Datum",
  time: "Čas",
  scheduled_for_publication: "Načrtovano za objavo",
  article_will_be_published_on: "Članek bo objavljen:",
  reset_selection: "Ponastavi izbiro",
  continue: "Nadaljuj",
  cancel: "Prekliči",
  // Member Selection
  error_loading_members: "Napaka pri nalaganju članov",
  please_fill_all_fields: "Prosimo, izpolnite vsa polja",
  invalid_email: "Neveljaven e-poštni naslov",
  member_added_successfully: "Član uspešno dodan",
  error_onboarding_user: "Napaka pri dodajanju uporabnika",
  error_creating_chat: "Napaka pri ustvarjanju klepeta",
  error_creating_group: "Napaka pri ustvarjanju skupine",
  new_group: "Nova skupina",
  please_select_or_enter_group_name: "Prosimo, izberite skupino ali vnesite ime skupine",
  please_select_or_enter_room_name: "Prosimo, izberite projekt ali vnesite ime projekta",
  error_creating_room: "Napaka pri ustvarjanju projekta",
  error_opening_chat: "Napaka pri odpiranju klepeta",
  privacy_modal_text: "Izberite \"Zasebno\" samo, če klepet ne vsebuje ustrezne strokovne vsebine za vodjo projekta.",
  not_private: "Ni zasebno",
  private: "Zasebno",
  error_loading_groups: "Napaka pri nalaganju skupin",
  automatic_chat_export: "Samodejni izvoz klepeta",
  automatic_chat_export_info: "Po aktivaciji bo zgodovina klepeta samodejno poslana na določen e-poštni naslov vsak mesec.",
  automatic_chat_export_no_email: "Za omogočanje samodejnega izvoza klepeta morate najprej dodati e-poštni naslov. Svoj e-poštni naslov lahko dodate v osebnih nastavitvah.",
  enter_email: "Vnesite e-pošto",
  update: "Posodobi",
  confirm: "Potrdi",
  export_to_email: "Izvoz gre na naslednjo e-pošto.",
  start_chat_button:"Novo sporočilo",
  matching_existing_chats: "Ujemajoči se obstoječi klepeti",
  subject: "Zadeva",
  add_subject: "Dodaj zadevo",
  chat_subject: "Zadeva klepeta:",
  set_project_room: "Nastavi projekt",
  matching_existing_project_rooms: "Ujemajoči se obstoječi projekti",
  name_project_room: "Ime projekta",
  professional_or_private: "Strokovno ali zasebno",
  professional: "Strokovno",
  privacy_modal_text_updated: "Izberite \"Zasebno\" samo, če klepet ne vsebuje ustrezne strokovne vsebine za vodje projektov. Zasebni klepeti niso vidni vodjem projektov.",
  create_internal_chat: "Zunanji - ali notranji klepet?",
  internal_chat_description: "Samo zaposleni vašega podjetja se lahko dodajo v interne klepete.",
  yes: "Da",
  no: "Ne",
  chat_is_being_created: "Klepet se ustvarja...",
  // Additional translations for hardcoded text
  discard_article_confirm: "Ali res želite zavreči spremembe tega članka?",
  please_enter_article_title: "Prosimo, najprej vnesite naslov članka.",
  please_add_mandatory_fields: "Prosimo, dodajte vsa obvezna polja",
  product_label: "Izdelek:",
  no_companies_found: "Podjetja niso bila najdena",
  visible_to_all_followers: "Vidno vsem članom Kjuup",
  only_visible_to_employees: "Vidno samo zaposlenim",
  something_went_wrong: "Nekaj je šlo narobe, prosimo poskusite znova",
  please_select_department: "Prosimo, izberite oddelek/lokacijo",
  schedule: "Načrtuj",
  please_select_future_date_time: "Prosimo, izberite prihodnji datum in čas za načrtovanje članka.",
  please_select_different_date_time: "Prosimo, izberite drug datum ali čas za načrtovanje članka.",
  please_select_later_time: "Prosimo, izberite čas pozneje kot trenutni čas za danes.",
  unpin_article: "Odpni članek",
  pin_article: "Pripni članek",
  and: "in",
  others: "drugi",
  at: "ob",
  // Chat mute/unmute translations
  mute: "Utišaj",
  unmute: "Prekliči utišanje",
  chat_muted_successfully: "Klepet uspešno utišan",
  chat_unmuted_successfully: "Utišanje klepeta uspešno preklicano",
  mute_chat_confirm: "Ali res želite utišati ta klepet? Ne boste več prejemali obvestil za nova sporočila.",
  unmute_chat_confirm: "Ali res želite preklicati utišanje tega klepeta? Ponovno boste prejemali obvestila za nova sporočila.",
  please_select_group_to_forward: "Prosimo, izberite skupino za posredovanje sporočila",
  // Company translations
  record_not_found: "Zapis ni najden!",
  please_select_position: "Prosimo, izberite položaj",
  delete_article_confirm: "Ali ste prepričani, da želite izbrisati ta članek?",
  delete_company_service_confirm: "Ali ste prepričani, da želite izbrisati storitev podjetja?",
  block_translation_confirm: "Ali res želite blokirati samodejni prevod v projektih za vse člane podjetja",
  unblock_translation_confirm: "Ali res želite odblokirati samodejni prevod v projektih za vse člane podjetja",
  please_select_file: "Prosimo, izberite datoteko za nalaganje",
  role_in_building_industry: "Vloga v gradbeni industriji*",
  invalid_email_address: "Neveljaven e-poštni naslov",
  please_enter_password: "Prosimo, vnesite geslo",
  password_change_email_sent: "Na vaš e-poštni naslov Kjuup je bilo poslano e-pošto. Potrdite novo geslo s klikom na povezavo za potrditev v e-pošti.",
  please_enter_username: "Prosimo, vnesite uporabniško ime",
  username_same_as_before: "Uporabniško ime ne more biti enako kot prej",
  profile_deleted_successfully: "Profil uspešno izbrisan",
  hardware_requirements: "Zahteve strojne opreme",
  hardware_requirements_list: "• 4GB RAM<br/>• Hitrost procesorja min. 2GHz<br/>• Windows 7 ali višji / vse različice macOS",
  submitting: "Pošiljanje...",
  signing_in: "Prijavljanje...",
  please_enter_service_name: "Prosimo, vnesite ime storitve",
  something_went_wrong_error: "Aaaah! Nekaj je šlo narobe...",
  something_went_wrong_try_again: "Oprostite, nekaj je šlo narobe. Poskusite znova",
  position_label: "Položaj:",
  loading_room: "Nalaganje projekta...",
  navigating_to_room: "Navigacija v projekt",
  loading_chat: "Nalaganje klepeta...",
  translate: "Prevedi",
  show_original: "Prikaži izvirnik",
  saving: "Shranjevanje...",
  language_selection_info: "Izbira jezika se uporablja za vse e-poštne potrditve v zvezi s podjetjem.",
  // Navigation bar labels
  nav_call: "Klic",
  nav_home: "Domov",
  nav_messages: "Sporočila",
  nav_todo: "Naloge",
  nav_rooms: "Projekti",
  nav_all_rooms: "Vsi projekti",
  pinned_rooms_max: "Pripnete lahko do 10 projektov.",
  pinned_room_unpin: "Odpni",
  pinned_rooms_drop: "Povlecite projekt sem za hitro izbiro",
  nav_profile: "Profil",
  nav_company: "Podjetje",
  nav_company_documents: "Dokumenti",
  nav_logout: "Odjava",
  // Create message dialog
  add_member_title: "Dodaj člana",
  continue_btn: "Nadaljuj",
  search_placeholder: "Iskanje",
  no_members_found: "Člani niso bili najdeni",
  no_groups_found: "Skupine niso bile najdene",
  no_rooms_found: "Projekti niso bili najdeni",
  search_users_tab: "Uporabniki",
  search_documents_tab: "Dokumenti",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "Ni datotek",
  no_documents_available: "No documents",
  searching_users: "Iskanje uporabnikov...",
  no_users_found: "Noben uporabnik ni bil najden",
  search_emails_tab: "E-pošta",
  searching_emails: "Iskanje e-pošte...",
  no_emails_found: "Ni najdenih e-poštnih sporočil",
  search_email_addresses_tab: "E-Mail Addresses",
  search_email_content_tab: "E-Mail Content",
  searching_email_content: "Searching email content...",
  no_email_content_found: "No email content found",
  search_email_attachments_tab: "E-Mail Attachments",
  searching_email_attachments: "Searching attachments...",
  no_email_attachments_found: "No attachment matches found",
  email_attachments_label: "Attachments",  searching_email_addresses: "Searching addresses...",
  no_email_addresses_found: "No address matches found",
  email_subject_label: "Subject",
  email_body_label: "Body",
  email_address_received: "Received",
  email_address_sent: "Sent",
  unnamed_group: "Neimenovana skupina",
  unnamed_room: "Neimenovan projekt",
  all_members: "Vsi",
  room_label: "Projekt:",
  subject_label: "Zadeva:",
  no_members: "Ni članov",
  // Loading states for room creation
  creating_structure: "Ustvarjanje vaše strukture",
  opening_chat: "Odpiranje klepeta",
  please_wait: "Prosimo, počakajte...",
  // ToDo page translations
  loading_todo: "Nalaganje ToDo...",
  task_updated: "Opravilo posodobljeno",
  error_updating_task: "Napaka pri posodabljanju opravila",
  task_deleted: "Opravilo izbrisano",
  error_deleting_task: "Napaka pri brisanju opravila",
  delete_task_confirm: "Ali ste prepričani, da želite izbrisati to opravilo?",
  description_label: "Opis",
  description_placeholder: "Vnesite opis...",
  date_time_label: "Datum in čas",
  save_hint: "Ctrl+Enter za shranjevanje, Esc za preklic",
  edit_label: "Uredi",
  delete_label: "Izbriši",
  todo_list_title: "Naloge",
  tasks_count: "opravila",
  search_placeholder_todo: "Iskanje...",
  select_task_to_open_chat: "Izberite opravilo za odpiranje klepeta",
  today: "Danes",
  yesterday: "Včeraj",
  time_suffix: "", // Prazno za slovenščino (24-urni format ne potrebuje pripone)
  from_chat: "Vir opravila",
  assigned_to: "Dodeljeno",
  assign_users: "Dodeli uporabnike",
  no_users_assigned: "Ni dodeljenih uporabnikov",
  assign: "Dodeli",
  assign_to: "Dodeli...",
  navigate_to_chat: "Pojdi na klepet",
  navigate_to_email: "Pojdi na e-pošto",
  show_original_message: "Prikaži vir",
  hide_original_message: "Skrij vir",
  status_pending: "Čakajoče",
  status_in_progress: "V teku",
  status_completed: "Zaključeno",
  show: "Prikaži",
  close: "Zapri",
  // Log translation strings
  status_confirmed: "[Potrjeno]",
  log_todo_created: "Opravilo [ustvarjeno]",
  log_todo_confirmed: "Opravilo [potrjeno]",
  log_todo_deleted: "Opravilo [izbrisano]",
  log_todo_updated: "Opravilo [posodobljeno]",
  log_description_updated: "[Opis posodobljen]",
  log_deadline_updated: "[Rok posodobljen]",
  log_assigned_to: "[Dodeljeno uporabniku] {name}",
  log_unassigned_from: "[Odstranjena dodelitev od] {name}",
  log_assignment_added: "[Dodelitev dodana]: {name}",
  log_assignment_removed: "[Dodelitev odstranjena]: {name}",
  log_status_updated: "[Status spremenjen iz] {from} [v] {to}",
  log_status_changed: "[Status spremenjen]",
  log_status_changed_to: "[Status spremenjen v] {status}",
  log_changed_status_to: "[Spremenil status v]:",
  log_for_user: "[za uporabnika]:",
  log_user_updated_status: "[Uporabnik je posodobil svoj status opravila]",
  log_changed_date_to: "[Spremenil datum v]:",
  log_changed_description_to: "[Spremenil opis v]:",
  log_moved_to: "[Premaknjeno v] {status}",
  todo_status_updated_from: "[iz]",
  todo_status_updated_to: "[v]",
  filter_pending: "V čakanju",
  filter_confirmed: "Potrjeno",
  filter_assigned_to_me: "Moje naloge",
  filter_assigned_by_me: "Delegirano",
  todo_project_label: "Projekt:",
  assigned_users: "Dodeljeni uporabniki:",
  todo_chat_label: "Klepet:",
  history: "Zgodovina",
  todo_assigned_by: "Dodelil:",
  todo_assigned_push: "Dodeljeno ToDo:",
  todo_assigned_push_empty: "Dodeljen vam je nov ToDo.",
  search_groups: "Skupine",
  search_chat_groups: "Klepetne skupine",
  search_project_room: "Projekt",
  search_messages_tab: "Sporočila",
  searching_groups: "Iskanje skupin...",
  searching_rooms: "Iskanje projektov...",
  no_groups_found: "Ni najdenih skupin",
  no_rooms_found: "Ni najdenih projektov",
  create_poll: "Anketa",
  poll_question_label: "VPRAŠANJE",
  poll_question_placeholder: "Postavite vprašanje",
  poll_options_label: "MOŽNOSTI",
  poll_option: "Možnost",
  poll_add_option: "Dodaj možnost",
  poll_allow_multiple: "Dovoli več odgovorov",
  poll_multiple_allowed: "Izberite eno ali več možnosti",
  poll_select_option: "Izberite eno možnost",
  poll_view_votes: "Prikaži glasove",
  poll_vote_singular: "glas",
  poll_vote_plural: "glasov",
  poll_votes: "Rezultati glasovanja",
  poll_no_votes_yet: "Še ni glasov",
  transcript_step_processing: "Transkripcija poteka...",
  ai_transcript_tab: "AI-Transkripcija",
  ai_transcript_info: "Na voljo samo za glasovna sporočila, ustvarjena po 09.03.2026.",
  transcript_more: "...več",
  transcript_less: "...manj",
  ki_transcript_voice_message: "KI-Prepis glasovnega sporočila",
  ki_image_analysis: "AI analiza slike",
  type_message: "Vnesite sporočilo",
  email_tab_messages: "Sporočila",
  email_tab_email: "E-pošta",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "E-poštni računi",
  email_connect_gmail: "Poveži Gmail",
  email_connect_outlook: "Povezi Outlook",
  email_no_accounts: "Ni povezanih e-poštnih računov",
  email_no_accounts_hint: "Povežite e-poštni račun v nastavitvah profila",
  email_no_messages: "Ni e-pošte",
  email_from: "Od",
  email_to: "Za",
  email_subject: "Zadeva",
  email_disconnect: "Odklopi",
  email_disconnect_confirm: "Ali ste prepričani, da želite odklopiti ta e-poštni račun? Vsi sinhronizirani e-poštni sporočila bodo odstranjeni.",
  email_account_disconnected: "E-poštni račun uspešno odklopljen",
  email_account_disconnect_failed: "Računa ni bilo mogoče odklopiti",
  email_connecting: "Povezovanje...",
  email_account_connected: "Račun uspešno povezan",
  email_signature: "Signature",
  email_signature_placeholder: "Enter your email signature...",
  email_signature_save: "Save",
  email_signature_saved: "Saved",
  email_go_to_settings: "Pojdi v nastavitve",
  email_date: "Datum",
  email_reply: "Odgovori",
  email_forward: "Posreduj",
  email_copy_text: "Kopiraj besedilo",
  email_text_copied: "Kopirano!",
  email_text_copy_failed: "Besedila ni bilo mogoče kopirati.",
  email_delete: "Izbriši",
  email_not_spam: "Ni neželena pošta",
  email_not_spam_success: "E-pošta premaknjena v prejeto pošto.",
  email_not_spam_failed: "Premik v prejeto pošto ni uspel.",
  email_delete_confirm: "Ali ste prepričani, da želite izbrisati to e-pošto?",
  email_delete_from_folder: "Ali ste prepričani, da želite izbrisati iz {folder}?",
  email_delete_permanent_from_folder:
    "Ali ste prepričani, da želite trajno izbrisati iz {folder}? Tega dejanja ni mogoče razveljaviti.",
  email_save_draft_confirm: "Ali želite shraniti to e-pošto kot osnutek?",
  email_save_draft: "Shrani osnutek",
  email_discard: "Zavrzi",
  email_back_to_compose: "Nazaj k pisanju",
  email_draft_saved: "Osnutek shranjen.",
  email_draft_save_failed: "Shranjevanje osnutka ni uspelo.",
  email_loading: "Nalaganje e-pošte...",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "Izberi",
  email_attachment_singular: "Priloga",
  email_attachment_plural: "Priloge",
  email_back: "Nazaj",
  email_download: "Prenesi",
  email_close: "Zapri",
  email_preview: "Predogled",
  email_preview_not_available: "Predogled ni na voljo",
  email_preview_failed: "Predogled ni na voljo",
  select_attachments: "Izberi priloge",
  email_loading_preview: "Nalaganje predogleda...",
  email_mark_unread_failed: "e-pošte ni mogoče označiti kot neprebrane.",
  email_delete_failed: "e-pošte ni mogoče izbrisati.",
  filter_all: "Vse",
  filter_email: "E-Mail",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "Neposredna sporočila",
  my_notes: "My Space",
  filter_internal_groups: "Interni skupinski klepeti",
  filter_external_groups: "Zunanji skupinski klepeti",
  filter_group_chats: "Skupinski klepeti",
  filter_groups_internal: "Interni",
  filter_groups_external: "Zunanji",
  filter_unread_only: "Samo neprebrano",
  room_daily_briefing_info: "Če je omogočeno, se poročilo za ta projekt ustvari vsakih 24 ur ob uri iz osebnih nastavitev — vendar le, če je v tem obdobju potekala aktivnost.",
  email_select_all: "Izberi vse",
  email_deselect_all: "Prekliči izbor",
  email_reply_all: "Odgovori vsem",
  email_reply_placeholder: "Vnesite odgovor...",
  email_forward_placeholder: "Dodajte sporočilo...",
  email_edit_draft: "Uredi osnutek",
  email_attach: "Priloži",
  email_attachment_from_original: "Iz izvirnega sporočila",
  email_remove: "Odstrani",
  email_drop_files: "Spustite datoteke za prilogo",
  email_loading_attachments: "Nalaganje prilog...",
  email_archive: "Arhiviraj",
  mark_unread: "Označi kot neprebrano",
  mark_read: "Označi kot prebrano",
  email_all_accounts: "Vsi računi",
  email_error: "Napaka",
  email_delete_email_failed: "E-pošte ni mogoče izbrisati.",
  enter_url: "Vnesite URL",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: 'Naroči se zdaj',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: '1 MESEC BREZPLAČNEGA PREIZKUSA',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: 'Danes ni plačila. Podatki kreditne kartice se ne zahtevajo, dokler se ne začne plačljiva naročnina.',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now � no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'Upravljajte vse e-poštne račune neposredno v Kjuupu',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'UI piše odgovore – vi samo potrdite',
  kjuup_io_feature_tasks: 'Opravila in koledar vedno samodejno posodobljeni',
  kjuup_io_choose_plan: 'Izberite paket',
  kjuup_io_plan_monthly: 'Mesečno',
  kjuup_io_plan_yearly: 'Letno',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Zaščiteno s Stripe · odpoved kadar koli',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: 'Plačilo prejeto. Naročnina se aktivira…',
  kjuup_io_toast_activating_soon: 'Plačilo prejeto. Vaša naročnina bo kmalu aktivirana.',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: 'Še {count} h',
  kjuup_io_trial_left_hour: 'Še 1 ura',
  kjuup_io_trial_left_minutes: 'Še {count} min',
  kjuup_io_trial_left_minute: 'Še 1 minuta',
  kjuup_io_trial_left_seconds: 'Še {count} s',
  kjuup_io_trial_left_second: 'Še 1 sekunda',
  kjuup_io_trial_ending_now: 'Preizkusno obdobje se izteka…',
  kjuup_io_request_timeout: 'Povezava je potekla. Poskusite znova.',
  kjuup_io_info_days_free: '{days} dni popolnoma brezplačno – naročnina se začne šele po preizkusu.',
  kjuup_io_discount_total: 'Vaš popust: {percent} %',
  kjuup_io_discount_company: '{company}: {percent} %',
  kjuup_io_discount_personal: 'Osebni: {percent} %',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: 'Zapri',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: 'Vaše brezplačno preizkusno obdobje je poteklo',
  kjuup_io_trial_ended_body: 'Naročite se na Kjuup.io, da boste še naprej lahko uporabljali e-pošto in druge premium funkcije.',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: 'Vaše brezplačno preizkusno obdobje se je začelo',
  kjuup_io_toast_trial_fail: 'Preizkusnega obdobja ni bilo mogoče začeti',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / mesec',
  kjuup_io_save_amount_year: 'Prihranite {price} na leto',
  kjuup_io_billed_annually_amount: '{price} zaračunano letno',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: 'Kaj dobite:',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: 'Kreditna kartica ni potrebna – začnite takoj brez plačilnih podatkov.',
  kjuup_io_info_cancel_anytime: 'Prekličite kadar koli – brez obveznosti, brez tveganja.',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: 'Obračunsko obdobje',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: 'Plačilno sredstvo shranjeno. Obračun sledi ob koncu preizkusnega obdobja.',
  calendar_sync_info: 'Samodejno sinhroniziraj vse Kjuup ToDo naloge s koledarjem.',
  calendar_no_accounts: 'Še ni povezan noben koledar.',
  article_new_badge: 'NOVO',
  article_new_posts: '{0} novih objav',
  documents: 'Dokumenti',
  add_documents: 'Dodaj dokumente',
  no_preview_available: 'Predogled ni na voljo',
  no_preview_hint: 'Te vrste datoteke ni mogoče predogledati, vendar bo vseeno poslana.',
  max_documents_reached: 'Hkrati lahko pripnete največ 10 dokumentov.',
  open_file: 'Odpri datoteko',
  twofa_title: 'Dvostopenjsko preverjanje',
  twofa_method_totp: 'Aplikacija za preverjanje',
  twofa_method_sms: 'SMS',
  twofa_method_email: 'E-pošta',
  twofa_enter_app: 'Vnesi 6-mestno kodo iz aplikacije.',
  twofa_enter_sms: 'Vnesi 6-mestno kodo, ki smo jo poslali s SMS-om.',
  twofa_enter_email: 'Vnesi 6-mestno kodo, ki smo jo poslali na e-pošto.',
  twofa_resend: 'Pošlji kodo znova',
  twofa_try_another: 'Druga metoda',
  twofa_remember_device: 'Na tej napravi 30 dni ne sprašuj',
  twofa_sent: 'Poslali smo kodo.',
  twofa_invalid_code: 'Ta koda ni pravilna. Poskusi znova.',
  twofa_something_wrong: 'Nekaj je šlo narobe. Poskusi znova.',
  twofa_method_unavailable: 'Ta metoda ni na voljo.',
  twofa_on_desc: 'Dvostopenjsko preverjanje je vklopljeno. Ob vsaki prijavi potrebuješ kodo.',
  twofa_off_desc: 'Dodaj drugi korak po geslu. Aplikacije so najvarnejša možnost.',
  twofa_methods: 'Metode',
  twofa_on: 'Vklopljeno',
  twofa_add: 'Dodaj',
  twofa_default_method: 'Privzeta metoda',
  twofa_default: 'Privzeto',
  twofa_turn_off: 'Izklopi',
  twofa_disable_hint: 'Vnesi geslo in trenutno kodo, da izklopiš dvostopenjsko preverjanje.',
  twofa_disable_need: 'Vnesi geslo in potrditveno kodo.',
  twofa_code_placeholder: '6-mestna ali rezervna koda',
  twofa_send_code: 'Pošlji kodo',
  twofa_primary_updated: 'Privzeta metoda je posodobljena.',
  twofa_disabled: 'Dvostopenjsko preverjanje je izklopljeno.',
  twofa_enabled: 'Dvostopenjsko preverjanje je zdaj vklopljeno.',
  twofa_totp_help: 'Skeniraj to kodo QR z Google Authenticator, Authy ali 1Password. Ključ lahko vpišeš tudi ročno.',
  twofa_secret_copied: 'Ključ je kopiran',
  twofa_sms_help: 'Vnesi številko v mednarodni obliki. 6-mestno kodo pošljemo s SMS-om.',
  twofa_email_help: '6-mestno kodo pošljemo na e-pošto računa.',
  twofa_backup_title: 'Rezervne kode',
  twofa_backup_help: 'Shrani te enkratne kode na varno. Vsaka koda se uporabi enkrat, če izgubiš telefon.',
  twofa_copy_codes: 'Kopiraj kode',
  twofa_codes_copied: 'Rezervne kode so kopirane',
  twofa_regenerate: 'Pridobi nove rezervne kode',
  twofa_regenerate_hint: 'To nadomesti neuporabljene rezervne kode. Vnesi geslo in trenutno kodo.',
  twofa_backup_remaining: 'Preostalo je {n} neuporabljenih rezervnih kod',
  twofa_new_codes: 'Nove rezervne kode',
  twofa_sms_unavailable: 'Kode SMS še niso na voljo.',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "Dodeljena opravila Kjuup se kopirajo v projekt Kjuup v tvojem Todoistu. Spremembe v Todoistu se ne kopirajo nazaj.",
  todoist_connect: "Poveži Todoist",
  todoist_connected: "Todoist je povezan",
  todoist_connect_failed: "Povezava s Todoistom ni uspela",
  todoist_disconnect: "Prekini povezavo",
  todoist_disconnected: "Todoist je odklopljen",
  todoist_disconnect_confirm: "Prekineš povezavo s Todoistom? Opravila, ki so že v Todoistu, ostanejo. Sinhronizacija se ustavi.",
  todoist_sync_now: "Sinhroniziraj zdaj",
  todoist_syncing: "Sinhroniziranje…",
  todoist_sync_done: "Sinhronizacija končana",
  todoist_sync_failed: "Sinhronizacija ni uspela",
  todoist_auth_error: "Znova poveži Todoist, da se sinhronizacija nadaljuje.",
  todoist_last_sync: "Zadnja sinhronizacija",
  todoist_not_connected: "Todoist ni povezan",
  todoist_auth_url_failed: "Strani za pooblastitev Todoista ni bilo mogoče odpreti.",
  recommend_text: "Pridruži se Kjuupu, ostani povezan in imej svojo komunikacijo urejeno. Združi svoje kanale, ohranjaj sporočila v pravih projektih in vsako jutro začni s povzetkom in svojimi nalogami – vse sinhronizirano z aplikacijami, ki jih že uporabljaš. Začni brezplačno:",
  pro_auth_signin_title: 'Dobrodošli nazaj',
  pro_auth_signin_sub: 'Prijavite se s svojo službeno e-pošto.',
  pro_auth_email_or_username: 'E-pošta ali uporabniško ime',
  pro_auth_email_placeholder: 'ime@podjetje.si',
  pro_auth_forgot_password: 'Ste pozabili geslo?',
  pro_auth_create_account: 'Ustvari račun',
  pro_auth_show_password: 'Prikaži geslo',
  pro_auth_hide_password: 'Skrij geslo',
  pro_auth_register_sub: 'Poslali vam bomo povezavo za potrditev vaše e-pošte.',
  pro_auth_register_plus_sub: 'Izberite uporabniško ime in geslo. Nato nastavite svoj varnostni PIN.',
  pro_auth_check_credentials: 'Preverite svojo e-pošto in geslo',
  pro_news_export_pdf: 'Izvozi kot PDF',
  pro_news_pdf_failed: 'PDF-ja ni bilo mogoče ustvariti.',
  pro_news_pdf_attachments: 'Priloge',
  pro_news_pdf_video: 'Video',
  pro_auth_forgot_sub: 'Vnesite svojo e-pošto in poslali vam bomo povezavo za ponastavitev gesla.',
  pro_auth_send_link: 'Pošlji povezavo za ponastavitev',
  pro_auth_plus_reset: 'Ponastavi s PIN-om',
  pro_auth_show_pin: 'Prikaži PIN',
  pro_auth_hide_pin: 'Skrij PIN',
  v2_auth_plus_only: 'Samo Kjuup+',
  room_action_media: "Datoteke",
  room_tab_overview: "Pregled",
  room_tab_history: "Zgodovina",
  chat_info_media: "Datoteke",
  messages: "sporočila",
  pro_todo_project_required: "Izberite projekt",
  pro_todo_choose_project: "Za kateri projekt je ta naloga?",
  cockpit_report_delete_confirm: "Izbrišem to dnevno poročilo?",
  cockpit_report_deleted: "Dnevno poročilo izbrisano",
  cockpit_tab_company: "Podjetje",
  cockpit_bookmarked_priorities: "Zaznamovana opravila",
  cockpit_load_error: "Kokpita ni bilo mogoče naložiti.",
  cockpit_retry: "Poskusi znova",
  cockpit_yesterday: "Včeraj",
  cockpit_greeting_morning: "Dobro jutro",
  cockpit_greeting_day: "Dober dan",
  cockpit_greeting_evening: "Dober večer",
  cockpit_assistant_q_open: "Kaj je danes odprto?",
  cockpit_assistant_q_summarize: "Povzemi klepet {{room}}",
  cockpit_assistant_q_overdue: "Katera opravila so zamujena?",
  cockpit_assistant_new: "{{n}} novih",
  cockpit_assistant_important: "{{n}} pomembnih",
  cockpit_assistant_title: "Pomočnik Kjuup",
  cockpit_assistant_hint: "Tapnite in vprašajte",
  room_overview_priority_no_detail: "Poročilo ne navaja dodatnih podrobnosti o tej prednostni nalogi.",
  room_overview_priority_from: "Vir: {{name}}",
  room_overview_priority_open_task: "Odpri opravilo",
  cockpit_priority_position: "{{index}} od {{total}} prioritet",
  room_overview_today_title: "Danes pomembno",
  room_overview_all_tasks: "Vse",
  room_overview_tasks_empty: "Ni odprtih rokov ali opravil",
  room_overview_appointments_empty: "Ni prihajajočih terminov",
  room_overview_no_priorities: "Ni odprtih prednostnih nalog v zadnjem poročilu.",
  cockpit_report_top5: "Top 5 prednostnih nalog",
  cockpit_report_todo_created: "Opravilo ustvarjeno",
  cockpit_report_source_missing: "Izvorno sporočilo ni bilo najdeno.",
  delete_bookmarked_priority_confirm: "Ali res želite izbrisati to zaznamovano opravilo?",
  cockpit_report_create_todo: "Ustvari opravilo",
  cockpit_priorities_deleting: "Brisanje …",
  cockpit_priorities_select: "Izbriši več",
  cockpit_report_none: "Ni vnosov.",
  cockpit_priorities_delete_confirm: "Ali res želite izbrisati {count} zaznamovanih opravil?",
  cockpit_priorities_delete_failed: "Brisanje {count} opravil ni uspelo",
  cockpit_priorities_deleted: "{count} opravil izbrisanih",
  cockpit_priorities_selected: "{count} izbranih",
  cockpit_channel_connected: "Povezano",
  cockpit_channel_not_connected: "Ni povezano",
  cockpit_channel_connect: "Poveži",
  cockpit_channel_chat: "Klepet Kjuup",
  cockpit_channel_active: "Aktivno",
  cockpit_channel_hidden: "Skrito",
  cockpit_channel_enable: "Omogoči",
  cockpit_channel_email: "E-pošta",
  cockpit_channel_check: "Preveri povezavo",
  cockpit_channel_fix: "Preveri",
  cockpit_channel_forward: "Naslov za posredovanje",
  cockpit_channel_not_set_up: "Ni nastavljeno",
  cockpit_channel_set_up: "Nastavi",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "Povezava prekinjena",
  cockpit_channel_importing: "Uvoz poteka",
  cockpit_channel_removing: "Prekinjanje povezave",
  cockpit_channel_reconnect: "Ponovno poveži",
  cockpit_channels_title: "Kanali",
  cockpit_company_role_super_admin: "Skrbnik podjetja",
  cockpit_company_role_dept_admin: "Skrbnik oddelka",
  cockpit_company_role_member: "Sodelavec",
  cockpit_company_none: "Podjetje Kjuup+ ni bilo najdeno",
  cockpit_company_eyebrow: "Podjetje",
  cockpit_company_inactive: "neaktivno",
  cockpit_company_settings: "Nastavitve podjetja",
  cockpit_company_employees: "Zaposleni",
  cockpit_company_internal_rooms: "Notranji projekti",
  cockpit_report_all_projects: "Vsi projekti",
  cockpit_report_progress_emails: "Analiza e-poštnih sporočil",
  cockpit_report_progress_chats: "Analiza sporočil klepeta",
  cockpit_report_progress_documents: "Analiza prilog in dokumentov",
  cockpit_report_progress_tasks: "Analiza opravil",
  cockpit_report_progress_summarizing: "Analiza vsebine",
  cockpit_report_progress_reading: "Ponovna uporaba že analizirane vsebine",
  cockpit_report_progress_collecting: "Zbiranje e-pošte, klepetov in opravil iz vaših projektov",
  cockpit_report_progress_priorities: "Priprava prednostnih nalog, rokov in odločitev",
  cockpit_report_progress_queued: "Priprava poročila",
  cockpit_report_creating_title: "Vaše dnevno poročilo se pripravlja",
  cockpit_report_progress_count_one: "1 element analiziran",
  cockpit_report_progress_count_many: "{{count}} elementov analiziranih",
  cockpit_report_progress_hint: "To običajno traja eno do dve minuti – med tem lahko kokpit uporabljate naprej.",
  cockpit_report_time_hint: "Dnevno poročilo se ustvari vsak dan ob {{hour}}:00 za pet najaktivnejših projektov.",
  room_overview_priorities_title: "Trenutno stanje in prednostne naloge",
  room_overview_as_of: "Stanje: {{time}}",
  cockpit_report_delete: "Izbriši dnevno poročilo",
  email_tag_daily_briefing: "Dnevno poročilo",
  cockpit_report_unread: "Novo",
  cockpit_report_clear_project: "Prikaži vse projekte",
  cockpit_filter_project: "Projekt",
  cockpit_filter_all_projects: "Vsi projekti",
  cockpit_report_recreate: "Znova ustvari dnevno poročilo",
  cockpit_report_hide_previous: "Skrij prejšnja dnevna poročila",
  cockpit_report_show_previous: "Prikaži prejšnja dnevna poročila",
  cockpit_report_room_empty: "Za ta projekt še ni dnevnega poročila",
  cockpit_report_empty: "Še ni dnevnega poročila",
  cockpit_report_room_empty_hint: "Ustvarite dnevno poročilo samo za ta projekt.",
  cockpit_report_needs_mailbox: "Povežite e-poštni račun, da bo Kjuup ustvaril dnevno poročilo s samodejnimi opravili.",
  cockpit_report_create: "Ustvari dnevno poročilo",
  cockpit_email_connect: "Poveži e-pošto",
  cockpit_email_none_title: "Še ni povezanega e-poštnega računa",
  cockpit_email_none_reports: "Povežite poštni predal, da bo Kjuup dohodna e-sporočila razvrstil v vaše projekte in iz njih ustvaril dnevna poročila z opravili.",
  cockpit_email_none_client: "Povežite Gmail, Outlook ali IMAP za branje, razvrščanje in odgovarjanje na e-pošto neposredno v Kjuup.io.",
  cockpit_email_reports_title: "Dosedanji e-poštni odjemalec",
  cockpit_email_reports_text: "Ni predala v Kjuup.io · {{rooms}} projektov z dnevnim poročilom ob {{hour}}:00 · dohodna e-sporočila se razvrščajo v vaše projekte.",
  cockpit_email_reports_rooms: "Upravljaj projekte",
  cockpit_email_settings: "E-poštne nastavitve",
  cockpit_email_error_title: "Preveri povezavo",
  cockpit_email_client_title: "Prejem nastavljen",
  cockpit_email_accounts_n: "{{n}} povezan račun",
  cockpit_email_last_sync: "zadnja sinhronizacija {{when}}",
  cockpit_email_report_at: "Dnevno poročilo ob {{hour}}:00",
  cockpit_email_open_inbox: "Odpri nabiralnik",
  cockpit_email_eyebrow: "Kjuup-Email",
  cockpit_email_accounts_label: "Povezani e-poštni naslovi",
  email_folder_sent: "Poslani",
  email_no_subject: "(Brez zadeve)",
  cockpit_email_detail_loading: "Nalaganje e-pošte …",
  cockpit_email_detail_failed: "E-pošte ni bilo mogoče naložiti.",
  cockpit_email_detail_empty: "To e-sporočilo nima besedila.",
  cockpit_personal_settings: "Osebne nastavitve",
  cockpit_companies: "Podjetja",
  cockpit_title: "Kokpit",
  cockpit_back: "Nazaj na pregled",
  cockpit_day_overview: "Vaš dan na prvi pogled",
  email_saved_to_project: "E-pošta shranjena v projekt",
  email_classify_need_project: "Vnesite ime projekta",
  cockpit_email_deleted: "E-pošta izbrisana",
  cockpit_email_sent_empty: "Še ni poslanih e-sporočil.",
  cockpit_email_incoming_empty: "Še ni prejetih e-sporočil.",
  cockpit_email_incoming_title: "E-pošta",
  cockpit_email_incoming_sub: "Dohodna in poslana e-sporočila razvrstite v svoje projekte. Razvrstitev lahko prilagodite tukaj.",
  cockpit_email_incoming_unassigned_n: "{{n}} nerazvrščenih",
  cockpit_email_folder_inbox: "Prejeto",
  cockpit_email_folder_sent: "Poslano",
  cockpit_email_open: "Odpri e-pošto",
  cockpit_email_incoming_suggested: "Predlog: {{room}}",
  cockpit_email_incoming_apply: "Uporabi",
  cockpit_email_incoming_adjust: "Prilagodi razvrstitev",
  cockpit_email_incoming_saving: "Shranjevanje …",
  cockpit_email_incoming_unassigned: "Nerazvrščeno",
  cockpit_email_incoming_show_less: "Prikaži manj",
  cockpit_email_incoming_show_all: "Prikaži vse {{n}}",
  cockpit_io_settings: "Nastavitve Kjuup.io",
  cockpit_io_settings_sub: "Paket in mesta, dodelitev zaposlenih, obračun in računi.",
  products_coming_soon: "Kmalu na voljo",
  cockpit_upsell_io_title: "Pisarna, ki razmišlja z vami",
  cockpit_upsell_io_text: "Povežite svoje e-poštne račune s Kjuup. E-pošta, priloge in sporočila se samodejno shranijo v ustrezen projekt in jih je mogoče po želji shraniti na vaš strežnik. Vsak dan prejmete povzetek vseh projektov s ključnimi točkami iz vseh vsebin, vaša opravila pa se sinhronizirajo s koledarjem ali aplikacijo za opravila.",
  cockpit_upsell_io_soon_title: "Še ni na voljo za naročilo",
  cockpit_upsell_io_soon_text: "Kjuup.io se kmalu začne. Zahtevajte informacije – obvestili vas bomo, takoj ko boste lahko naročili Kjuup.io.",
  cockpit_upsell_io_planned_price: "Načrtovana cena",
  cockpit_upsell_io_cta_request: "Zahtevaj informacije",
  kjuup_plus_abo_per_year: "/ leto",
  kjuup_plus_abo_per_month: "/ mesec",
  kjuup_plus_abo_status_active: "Aktivno",
  kjuup_plus_abo_status_requested: "Odpoved zahtevana",
  kjuup_plus_abo_status_past_due: "Plačilo zapadlo",
  kjuup_plus_abo_eyebrow: "Kjuup+ · Naročnina",
  kjuup_plus_abo_title: "Paket Kjuup+",
  kjuup_plus_abo_seats_free_one: "Še 1 prosto mesto",
  kjuup_plus_abo_billing: "Način plačila",
  kjuup_plus_abo_yearly: "Letno",
  kjuup_plus_abo_monthly: "Mesečno",
  kjuup_plus_abo_amount: "Znesek",
  kjuup_plus_abo_ends: "Poteče",
  kjuup_plus_abo_renews: "Naslednji podaljšek",
  kjuup_plus_abo_next_invoice: "Naslednji račun",
  kjuup_plus_abo_intro: "Uvodna cena",
  kjuup_plus_abo_pending_tier: "Od naslednjega podaljška",
  kjuup_plus_abo_manual: "Kjuup+ je za vaše podjetje aktiven na podlagi individualnega dogovora.",
  kjuup_plus_abo_invoices: "Računi",
  kjuup_plus_abo_invoice_paid: "Plačano",
  kjuup_plus_abo_invoice_view: "Poglej",
  kjuup_plus_abo_invoices_less: "Prikaži manj",
  kjuup_plus_abo_member_hint: "Obračun in odpoved upravljajo skrbniki podjetja.",
  kjuup_plus_abo_withdraw: "Umakni zahtevo",
  kjuup_plus_abo_cancel_note: "Razlog (neobvezno)",
  kjuup_plus_abo_cancel_send: "Zahtevaj odpoved",
  kjuup_plus_abo_cancel: "Odpovej naročnino",
  cockpit_upsell_plus_f1: "Upravljajte komunikacijske dejavnosti vseh zaposlenih",
  cockpit_upsell_plus_f2: "Obveščajte določene skupine uporabnikov v podjetju",
  cockpit_upsell_plus_f3: "Shranjujte interne skupinske klepete",
  cockpit_upsell_plus_when_yearly: "pri letnem plačilu",
  cockpit_upsell_plus_size_small: "1–50 zaposlenih",
  cockpit_upsell_plus_size_large: "51–200 zaposlenih",
  cockpit_upsell_plus_title: "Kjuup+ za podjetja",
  cockpit_upsell_plus_text: "Upravljajte zaposlene, pravice pisanja in komunikacijo podjetja na enem mestu. Notranji kanali ostanejo pri vaših zaposlenih, zunanji kanali vas povezujejo s projektnimi partnerji, določene skupine pa obveščate ciljno. Poleg Kjuup+ lahko naročite dostope Kjuup.io za skupine zaposlenih. Kjuup+ in Kjuup.io je mogoče kombinirati.",
  cockpit_upsell_plus_size: "Velikost podjetja",
  cockpit_upsell_plus_billing: "Način plačila",
  cockpit_upsell_plus_per_company: "/ podjetje · mesec brez DDV",
  cockpit_upsell_plus_onboarding: "Stroški uvedbe so odvisni od velikosti podjetja",
  cockpit_upsell_plus_larger: "Cene za večja podjetja na zahtevo",
  cockpit_upsell_plus_cta: "Povpraševanje brez obveznosti",
  cockpit_kpi_deadlines_tasks: "Roki in opravila",
  cockpit_kpi_appointments: "Termini",
  cockpit_room_admin: "Upravljanje projektov in klepetov",
  cockpit_room_admin_sub: "Vsi projekti podjetja s člani, mediji in klepeti.",
  pro_todo_not_found: "To opravilo ni več na voljo.",
  cockpit_chip_overdue: "Zamujeno",
  cockpit_chip_today: "Danes",
  cockpit_calendar_week: "{{week}}. teden",
  cockpit_prev_week: "Prejšnji teden",
  cockpit_next_week: "Naslednji teden",
  cockpit_chip_requested: "Zahtevano",
  cockpit_todo_due: "Rok {{when}}",
  cockpit_todo_at: "ob {{time}}",
  cockpit_todo_requested_from: "od {{name}}",
  cockpit_todo_since: "od {{when}}",
  cockpit_todo_no_date: "Brez datuma",
  cockpit_todo_mark_done: "Označi kot opravljeno",
  cockpit_my_tasks_title: "Moja opravila",
  cockpit_today_tasks_group: "Opravila danes",
  cockpit_assign_none: "Nihče ni dodeljen",
  no_project_found: "Projekt ni najden",
  cockpit_row_more_actions: "Več dejanj",
  needs_date: "Dodeli termin",
  cockpit_assign_proposal: "Prepoznano: {{name}} – dodelim?",
  cockpit_assign_proposal_confirm: "Dodeli",
  cockpit_assign_proposal_dismiss: "Prezri",
  cockpit_priority_date: "Datum",
  todo_calendar_add: "Dodaj v koledar",
  todo_calendar_remove: "Odstrani iz koledarja",
  cockpit_todo_change_project: "Spremeni projekt",
  cockpit_todo_set_date: "Nastavi datum",
  pro_todo_done_confirm: "Ali res želite to opravilo označiti kot opravljeno?",
  cockpit_task_delete_failed: "Opravila ni bilo mogoče izbrisati.",
  cockpit_setup_title: "Dokončajte nastavitev",
  cockpit_setup_text: "Odločite, ali želite uporabljati klepete in ali naj Kjuup.io deluje kot e-poštni odjemalec ali samo s projekti in dnevnimi poročili.",
  cockpit_setup_cta: "Nastavi zdaj",
  cockpit_group_tasks: "Roki in opravila",
  cockpit_group_appointments: "Termini",
  cockpit_report_no_activity: "V tem projektu v zadnjih 24 urah ni bilo novih sporočil ali e-pošte.",
  cockpit_report_room_unavailable: "Ta projekt ni na voljo.",
  cockpit_report_create_failed: "Dnevnega poročila ni bilo mogoče ustvariti.",
  cockpit_report_created: "Dnevno poročilo ustvarjeno",
  addon_enable_confirm: "Omogočim dodatek?",
  addon_enable: "Omogoči",
  addon_enabled: "Dodatek omogočen",
  nav_email: "E-pošta",
  nav_my_cockpit: "Moj kokpit",
  nav_news: "Novice",
  nav_recommend: "Priporoči",
  pro_todo_status_done: "Opravljeno",
  pro_todo_status_open: "Odprto",
  v2_todo_remove: "Odstrani",
  pro_todo_search_people: "Iskanje oseb",
  pro_todo_clear: "Ponastavi",
  pro_todo_assigned: "(dodeljeno)",
  pro_todo_no_people: "Ni najdenih oseb",
  pro_todo_search_rooms: "Iskanje projektov",
  pro_todo_no_rooms_match: "Noben projekt ne ustreza „{{q}}“",
  pro_todo_no_rooms: "Ni najdenih projektov",
  pro_todo_activity: "Dejavnost",
  pro_todo_show_less: "Prikaži manj",
  pro_todo_show_all: "Prikaži vse ({{n}})",
  pro_todo_due: "Zapade",
  pro_todo_room: "Projekt",
  pro_todo_select_room: "Izberi projekt",
  pro_todo_status: "Stanje",
  pro_todo_more: "Več",
  pro_todo_edit_title: "Uredi opravilo",
  pro_todo_description: "Opis",
  pro_todo_created_by: "Ustvaril(a)",
  pro_todo_chat: "Klepet",
  navigate_to_source: "Pojdi na vir",
  todo_calendar_connect_title: "Ni povezanega koledarja",
  todo_calendar_connect_body_web: "Povežite koledar v nastavitvah sinhronizacije koledarja, da mu dodate opravila.",
  todo_calendar_connect: "Poveži",
  todo_calendar_removed: "Odstranjeno iz vašega koledarja",
  todo_calendar_added_later: "Dodano. Koledar ni dosegljiv; Kjuup bo poskusil znova pozneje.",
  todo_calendar_added: "Dodano v vaš koledar",
  todo_calendar_no_date: "V koledar je mogoče dodati samo opravilo z datumom.",
  todo_calendar_failed: "Koledarja ni bilo mogoče posodobiti. Poskusite znova.",
  todo_calendar_date_title: "Še brez datuma",
  todo_calendar_date_save: "Nastavi datum in dodaj",
  todo_calendar_date_body_web: "To zaznamovano opravilo še nima datuma. Nastavite ga, da ga dodate v koledar.",
  kjuup_io_setup_saved: "Nastavitev shranjena",
  kjuup_io_setup_step: "Korak",
  kjuup_io_setup_chats_title: "Želite uporabljati klepete?",
  kjuup_io_setup_email_title: "Kje želite brati e-pošto?",
  kjuup_io_setup_chats_sub: "Klepeti s sodelavci in projektnimi partnerji so neobvezni. V kokpitu jih lahko kadar koli prikažete ali skrijete.",
  kjuup_io_setup_email_sub: "Tu le izberete, ali v Kjuup uporabljate e-poštni odjemalec ali še naprej uporabljate svoj dosedanji program, na primer Outlook ali drugega. Pozneje lahko zamenjate.",
  kjuup_io_setup_chats_yes: "Da, prikaži klepete",
  kjuup_io_setup_chats_yes_text: "Sporočila vsebujejo klepete in e-pošto. Projekti imajo skupinske klepete za vse udeležene.",
  kjuup_io_setup_chats_no: "Ne, delaj brez klepetov",
  kjuup_io_setup_chats_no_text: "Klepeti so skriti. „Sporočila“ postanejo „E-pošta“; projekti, opravila in dnevna poročila ostanejo.",
  kjuup_io_setup_email_client: "E-poštni odjemalec v Kjuup",
  kjuup_io_setup_email_client_text: "E-pošto berite in nanjo odgovarjajte neposredno v Kjuup.",
  kjuup_io_setup_email_reports: "Dosedanji e-poštni odjemalec",
  kjuup_io_setup_email_reports_text: "E-pošto berite in nanjo odgovarjajte še naprej v trenutnem programu, na primer Outlook ali drugem.",
  kjuup_io_setup_skip: "Pozneje",
  next: "Naprej",
  kjuup_io_setup_finish: "Dokončaj nastavitev",
  today_label: "danes",
  tomorrow_label: "jutri",
  cockpit_todo_overdue: "zamujeno",
  cockpit_report_management_fazit: "Povzetek za vodstvo",
  cockpit_todo_appointment: "Termin",
  cockpit_todo_deadline: "Rok",
  cockpit_todo_deadline_define: "Določi rok",
  pro_todo_status_acknowledged: "Potrjeno",
  pro_todo_responsible: "Odgovoren",
  pro_todo_notice_confirmed: "Potrjeno v klepetu",
  pro_todo_notice_sent_at: "Sporočilo poslano",
  pro_todo_notice_again: "Ponovno pošlji sporočilo",
  pro_todo_notice_send: "Obvesti s sporočilom Kjuup",
  pro_todo_add_assignee: "Dodaj",
  pro_todo_edit: "Uredi",
  pro_todo_change_room: "Spremeni projekt",
  pro_todo_due_on: "Zapade dne",
  pro_todo_edit_due: "Uredi rok",
  pro_todo_no_date: "Brez datuma",
  pro_todo_edit_description: "Uredi opis",
  pro_todo_no_description: "Še brez opisa",
  pro_todo_title_label: "Naslov",
  pro_todo_title_placeholder: "Vnesite naslov...",
  pro_todo_task: "Naloga",
  pro_todo_what: "Kaj je treba narediti?",
  pro_todo_source_email: "E-pošta",
  pro_todo_sources: "Viri",
  previous: "Prejšnje",
  kjuup_plus_abo_tier_large: "Kjuup+ Large (do {max} zaposlenih)",
  kjuup_plus_abo_tier_small: "Kjuup+ Small (do {max} zaposlenih)",
  kjuup_plus_abo_status_ends: "Poteče {date}",
  kjuup_plus_abo_seats_over: "Več kot {max} zaposlenih – Kjuup vas bo kontaktiral s prilagojeno ponudbo.",
  kjuup_plus_abo_seats_next: "Če se pridruži več zaposlenih, se paket samodejno spremeni v {next} (sorazmerni obračun).",
  kjuup_plus_abo_seats_used: "Zasedena mesta: {used} od {total}",
  kjuup_plus_abo_seats_free: "Prosta mesta: {count}",
  kjuup_plus_abo_intro_until: "do {date}",
  kjuup_plus_abo_invoice_open: "Odprto · zapade {date}",
  kjuup_plus_abo_invoices_all: "Prikaži vse ({count})",
  kjuup_plus_abo_requested_hint: "Odpoved zahtevana {date}. Kjuup jo potrdi ob koncu pogodbenega obdobja ({end}).",
  kjuup_plus_abo_cancel_hint: "Kjuup pregleda vašo zahtevo in potrdi odpoved ob koncu pogodbenega obdobja ({end}). Do takrat Kjuup+ ostane aktiven.",
  kjuup_plus_abo_withdrawn: "Zahteva za odpoved preklicana",
  kjuup_plus_abo_requested: "Odpoved zahtevana",
  cockpit_upsell_plus_intro_hint: "prve {months} mesece, nato {price}",
  cockpit_upsell_plus_badge: "UVODNA CENA ZA {months} MESECE",
  calendar_syncing: "Posodabljanje iz koledarja…",
  calendar_sync_up_to_date: "Koledar je ažuren",
  calendar_sync_failed: "Sinhronizacija ni uspela",
  delete_multiple_tasks_confirm: "Ali ste prepričani, da želite izbrisati {count} ToDo-jev?",
  todos_deleted_count: "Izbrisanih {count} ToDo-jev",
  todos_deleted_partial: "Izbrisanih {ok} ToDo-jev, {fail} neuspešnih",
  todo_unknown: "Neznano",
  todo_created_from_message: "Opravilo ustvarjeno iz tega sporočila",
  kjuup_io_todo_calendar_trial_ended_note: "Sinhronizacija koledarja · Naročite se",
  kjuup_io_todo_calendar_nudge: "Sinhronizirati ta ToDo s svojim koledarjem?",
  kjuup_io_todo_calendar_nudge_cta: "Aktiviraj Kjuup.io",
  todo_confirmed: "ToDo potrjeno",
  pro_todo_bulk_delete_title: "Izbrišem opravila ({{n}})?",
  pro_todo_previous_none_own: "Zapadla opravila so vam dodelili drugi in jih lahko izbrišejo samo oni.",
  pro_todo_previous_none: "Ni zapadlih opravil",
  pro_todo_previous_title: "Izbrišem zapadla opravila ({{n}})?",
  pro_todo_previous_text: "Vsa vaša odprta opravila iz prejšnjih dni bodo izbrisana.",
  pro_todo_previous_skipped: "Opravila, ki so vam jih dodelili drugi, ostanejo: {{n}}.",
  unassign_task_confirm: "Ali želite preklicati svojo dodelitev za to nalogo?",
  unassign_label: "Prekliči",
  pro_todo_delete_title: "Izbriši opravilo",
  pro_todo_today: "Danes",
  pro_todo_yesterday: "Včeraj",
  pro_todo_since_yesterday: "Od včeraj",
  pro_todo_mark_open: "Označi kot odprto",
  verify_completion: "Preveri",
  new_label: "Novo",
  bookmarked_no_mylist: "Zaznamovanih nalog ni mogoče dodati na Moj seznam",
  delete_only_own: "Izbrišete lahko samo opravila, ki ste jih ustvarili sami",
  todo_clear_all: "Počisti vse",
  pro_todo_of_completed: "Opravljeno {{done}} od {{total}}",
  pro_todo_pick_date: "Izberite datum",
  pro_todo_show_day: "Prikaži dan",
  todo_adjust_list: "Prilagodi seznam",
  pro_todo_section_upcoming: "Prihajajoče",
  pro_todo_section_done: "Opravljeno",
  pro_todo_room_empty_today: "Danes v tem projektu ni opravil",
  pro_todo_room_empty_day: "Ta dan v tem projektu ni opravil",
  pro_todo_delete_previous: "Izbriši vse",
  todo_my_list_empty: "Tvoj dan je prazen",
  todo_my_list_empty_hint: "Kliknite »Prilagodi seznam«, da dodate opravila",
  pro_todo_empty_title: "Tukaj ni ničesar",
  pro_todo_empty_hint: "Nobena naloga se ne ujema s tem pogledom.",
  pro_todo_selected: "Izbrano: {{n}}",
  delete_selected_count: "Izbriši ({count})",
  pro_todo_adjust_done: "Končano",
  pro_todo_deleting: "Brisanje...",
  pro_todo_reopen: "Znova odpri nalogo",
  pro_todo_step_done: "Opravljeno",
  move_back_in_progress: "Vrni v tek",
  pro_todo_mark_not_started: "Označi kot nezačeto",
  back_into_in_progress: "Nazaj v obdelavo",
  pro_todo_mark_in_progress: "Označi kot v teku",
  unassign_todo: "Prekliči dodelitev ToDo",
  pro_todo_open_room: "Odpri projekt",
  pro_todo_new_task: "Nova naloga",
  select_user_back_to_in_progress: "Izberite uporabnika, ki ga želite vrniti v tek",
  cockpit_email_accounts_n_many: "Povezani računi: {{n}}",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Stiki Kjuup",
  combined_tab_teams: "Stiki Teams",
  combined_bridge_failed: "Kopije v Teams ni bilo mogoče ustvariti.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Stiki Kjuup in Teams: ustvari se nova skupina, ki je vidna tudi v Microsoft Teams.",
  teams_new_chat_title: "Nov klepet Teams",
  teams_new_chat_topic: "Ime skupine (neobvezno)",
  teams_new_chat_start: "Začni klepet",
  teams_new_chat_creating: "Ustvarjanje klepeta…",
  teams_new_chat_forbidden: "Microsoft Teams ne dovoli tega klepeta (npr. oseba zunaj vaše organizacije ali pravilo vašega oddelka IT).",
  teams_new_chat_too_many: "Preveč oseb za en klepet.",
  teams_new_chat_type_hint: "Vnesite ime za iskanje v vaši organizaciji.",
  teams_new_chat_directory_forbidden: "Vaša organizacija ne dovoli iskanja v imeniku. Prikazane so samo osebe iz vaših klepetov Teams.",
  teams_new_chat_account: "Račun",
};
